import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import chartReducer from './reducers/chart/chartSlice';
import stockDetailsReducer from './reducers/stocks/stockDetailsSlice';
import smtReducer from './reducers/smt/smtSlice';
import indicesDetailsReducer from './reducers/indices/indicesDetailsSlice';
import etfDetailsReducer from './reducers/etf/etfDetailsSlice';

export const store = configureStore({
  reducer: {
    chart: chartReducer,
    stockDetails: stockDetailsReducer,
    smt: smtReducer,
    indicesDetails: indicesDetailsReducer,
    etfDetails: etfDetailsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
